(ns frontend.local-storage
  (:refer-clojure :exclude [get get-in set update update-in])
  (:require
   [alandipert.storage-atom :as storage-atom]
   [frontend.local-storage.repair :as repair]))

(def local-storage-available? (try
                                (.setItem js/window.localStorage "test" true)
                                true
                                (catch js/Object e
                                  false)))

(def ^:private local-storage (when local-storage-available?
                               (let [storage (storage-atom/local-storage (atom {}) :zapflow)]
                                 ;; A stored value with a part that the writer cannot write
                                 ;; would make each later write fail (DEV-8230).
                                 (repair/repair! storage)
                                 storage)))

(defn get [k]
  (when local-storage-available?
    (cljs.core/get @local-storage k)))

(defn get-in [path]
  (when local-storage-available?
    (let [ls (cljs.core/get-in @local-storage path)]
      ls)))

(defn set [k v]
  (when local-storage-available?
    (repair/assoc-in-writable! local-storage {:path  [k]
                                              :value v})))

(defn set-in [path v]
  (when local-storage-available?
    (repair/assoc-in-writable! local-storage {:path  path
                                              :value v})))

(defn update [k f & args]
  (when local-storage-available?
    (repair/assoc-in-writable! local-storage {:path  [k]
                                              :value (apply f (cljs.core/get @local-storage k) args)})))

(defn update-in [path f & args]
  (when local-storage-available?
    (repair/assoc-in-writable! local-storage {:path  path
                                              :value (apply f (cljs.core/get-in @local-storage path) args)})))
